import { disableBodyScroll, clearAllBodyScrollLocks } from '../body-scroll-lock'

const header = document.querySelector(".header") as HTMLElement | null;
const nav = header?.querySelector(".header-nav-main") as HTMLElement;
const isTouchDevice = matchMedia("(hover: none)").matches;
const submenuButtons = nav?.querySelectorAll(
  'button[aria-haspopup="true"]'
) as NodeListOf<HTMLAnchorElement> | null;

submenuButtons?.forEach((anchor: HTMLAnchorElement) => {
  anchor.addEventListener("mouseover", (e) => {
    openSubmenu(anchor);
  });
  anchor.addEventListener("mouseout", (e) => {
    const subMenu = anchor.nextElementSibling as HTMLUListElement;
    if (subMenu.contains(e.relatedTarget as Node)) {
      subMenu.addEventListener("pointerout", (e) => {
        // TODO: this will create a new event listener every time you hover over the submenu
        // is there any way to remove it?
        if (!subMenu.contains(e.relatedTarget as Node)) {
          closeSubmenus();
        }
      });
      return;
    }
    closeSubmenus();
  });
});

const toggleButton = header?.querySelector(".menu-toggle") as HTMLButtonElement;
toggleButton?.addEventListener("click", handleBurgerPress);

// if user touches outside of menu, close menu
document.addEventListener("click", (e) => {
  if (nav?.contains(e.target as Node)) {
    return;
  }
  closeSubmenus();
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    closeSubmenus();
  }
});

document.addEventListener("click", (e) => {
  if (nav?.contains(e.target as Node)) {
    return;
  }
  closeSubmenus();
});

window.addEventListener("resize", () => {
  closeMobileNav();
});

// if menu, add listener for keyboard controls
if (nav) {
  nav.addEventListener("keydown", (e) => {
    const activeElement = document.activeElement as HTMLAnchorElement;
    const navList = nav.querySelector(".header-nav-main-list") as HTMLUListElement;
    // const openSubmenu = navList.querySelector("button[aria-expanded='true']") as HTMLAnchorElement | null;
    // const activeTopLevel;

    if (e.key === "ArrowRight") {
      e.preventDefault();
      if (activeElement.closest(".header-nav-main-list-item").nextElementSibling) {
        activeElement
          .closest(".header-nav-main-list-item")
          .nextElementSibling?.firstElementChild.focus();
      } else {
        navList.firstElementChild?.firstElementChild?.focus();
      }
      closeSubmenus();
    }
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      if (activeElement.closest(".header-nav-main-list-item").previousElementSibling) {
        activeElement
          .closest(".header-nav-main-list-item")
          .previousElementSibling?.firstElementChild.focus();
      } else {
        navList.lastElementChild?.firstElementChild?.focus();
      }
      closeSubmenus();
    }
    if (e.key === "ArrowDown" || e.key === "Enter") {
      e.preventDefault();
      if (activeElement.getAttribute("aria-haspopup") === "true") {
        openSubmenu(activeElement);
        activeElement.nextElementSibling?.querySelector(".header-nav-secondary-link").focus();
      } else {
        // already in subnav, move to next item. if at end of list, wrap to first item
        const nextItem = activeElement.parentElement.nextElementSibling
          ? activeElement.parentElement.nextElementSibling?.firstElementChild
          : activeElement.closest(".sub-nav").firstElementChild?.firstElementChild;
        nextItem.focus();
      }
    }
    // arrow up should move within subnav
    if (e.key === "ArrowUp") {
      e.preventDefault();
      if (activeElement.getAttribute("aria-haspopup") === "true") {
        return;
      } else {
        const prevItem = activeElement.parentElement.previousElementSibling
          ? activeElement.parentElement.previousElementSibling?.firstElementChild
          : activeElement.closest(".sub-nav").lastElementChild?.firstElementChild;
        prevItem.focus();
      }
    }
  });
}
// right arrow or tab should move right within nav, or wrap at last
// left arrow or shift-tab should move left, or wrap at first
// down arrow, or enter should open submenu

function openSubmenu(submenu: HTMLAnchorElement) {
  const list = submenu.nextElementSibling as HTMLUListElement;
  list.classList.add("active");
  submenu.setAttribute("aria-expanded", "true");
  document.body.classList.add("nav-open");
}

function closeSubmenus() {
  const submenu = document.querySelector(
    ".header-nav-main button[aria-expanded='true']"
  ) as HTMLAnchorElement;

  if (!submenu) {
    return;
  }

  const list = submenu.nextElementSibling as HTMLUListElement;
  list.classList.remove("active");
  submenu.setAttribute("aria-expanded", "false");
  document.body.classList.remove("nav-open");
}

function handleBurgerPress() {
  const isNavOpen = toggleButton.getAttribute("aria-pressed") === "true";
  console.log("handleBurgerPress", isNavOpen ? "closing" : "opening");
  if (isNavOpen) {
    closeMobileNav();
  } else {
    openMobileNav();
  }
}

function openMobileNav() {
  const nav = header?.querySelector(".header-nav-main") as HTMLElement | null;
  toggleButton.setAttribute("aria-pressed", "true");
  disableBodyScroll(nav as HTMLElement);
  nav.style.display = "block";
  setTimeout(() => {
    nav?.classList.add("mobile-open");
  }, 100);
}

function closeMobileNav() {
  const nav = header?.querySelector(".header-nav-main") as HTMLElement | null;
  if (!nav?.classList.contains("mobile-open")) {
    return;
  }
  toggleButton.setAttribute("aria-pressed", "false");
  clearAllBodyScrollLocks();
  nav?.classList.remove("mobile-open");
  setTimeout(() => {
    nav.style.display = "none";
  }, 100);
}

// Sticky header
const observer = new IntersectionObserver(
  ([e]) => e.target.classList.toggle("is-stuck", e.intersectionRatio < 1),
  { threshold: [1] }
);

observer.observe(header as Element);
